import type { WorkspaceLocation } from 'honeygrid-types'

export const getCoordinatesFromLocation = (location: WorkspaceLocation) => {
	const latitude = Number(location?.latitude || 0)
	const longitude = Number(location?.longitude || 0)

	return { latitude, longitude }
}

export const getPlacesPhotoUrl = (photoReference?: string, maxwidth = 400) => {
	if (!photoReference) return

	const params = new URLSearchParams({
		maxwidth: maxwidth.toString(),
	})

	return `${
		import.meta.env.VITE_API_URL
	}/google-places/photos/${photoReference}?${params.toString()}`
}
